import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=086bb27a&"
var script = {}
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=086bb27a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports